import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import PollQuestion from './SmallComponents/PollQuestion'
import config from '../../config'
import UpdatesCard from './SmallComponents/UpdatesCard'
import DocumentCard from './SmallComponents/DocumentCard'
import FormRenderCard from './SmallComponents/FormRenderCard'
import Pageopenmodal from '../Modals/Pageopenmodal'
import PageHeader from '../Elements/UI/PageHeader'
import EmptyState from '../Elements/UI/EmptyState'
import FeedSkeleton from '../Elements/UI/FeedSkeleton'
import FeedTime from '../Elements/UI/FeedTime'
import PaymentDueAlert from '../Elements/UI/PaymentDueAlert'

// Visual metadata per post type
const typeMeta = {
  Updates: { label: 'Notice', icon: 'megaphone-outline', chip: 'bl-chip--primary', dot: 'bg-primary' },
  Vote: { label: 'Poll', icon: 'bar-chart-outline', chip: 'bl-chip--warning', dot: 'bg-warning' },
  Document: { label: 'Document', icon: 'document-text-outline', chip: 'bl-chip--neutral', dot: 'bg-secondary' },
  Form: { label: 'Form', icon: 'create-outline', chip: 'bl-chip--info', dot: 'bg-info' }
}

const Updates = () => {
  const [posts, setPosts] = useState([])
  const [showmodal,setShowmodal] = useState(false)
  const [loading, setLoading] = useState(true)
  const wideBlockRef = useRef()

  useEffect(()=>{
    const setmodal = localStorage.getItem('setmodal')
    if(!setmodal){
       setShowmodal(true)
       localStorage.setItem('setmodal',true)
    }else{
      setShowmodal(false)
    }  
  },[])

  // const setmodal = localStorage.setItem('showmodal')
  // console.log(setmodal)

  const handleClose = () =>{
    setShowmodal(false)
  }

 
  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 130
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  
  useEffect(() => {
    fetchAndEnrichPosts()
  }, [])

  const fetchAndEnrichPosts = async () => {
    const token = localStorage.getItem('token')
    try {
      
      const res = await axios.get(`${config.apiUrl}/post/getAll`, {
        headers: { Authorization: token }
      })
      let allPosts = res.data?.data || [];

      allPosts = allPosts.map(post => {
        if (
          post.Type === 'Form' &&
          post.Data?.FormID &&
          (!post.Data?.fields || post.Data.fields.length === 0)
        ) {
          return {
            ...post,
            Data: {
              ...post.Data,
              // ...formMap[post.Data.FormID]
            }
          }
        }
        return post
      })

      
      // const incompleteForms = allPosts.filter(
      //   item =>
      //     item.Type === 'Form' &&
      //     item.Data?.FormID &&
      //     (!item.Data?.fields || item.Data.fields.length === 0)
      // )

      // if (incompleteForms.length > 0) {
      //   try {
      //     const formRes = await axios.get(`${config.apiUrl}/post/Form`, {
      //       headers: { Authorization: token }
      //     })
      //     const fullForms = formRes.data?.data || []

          
      //     const formMap = {}
      //     fullForms.forEach(form => {
      //       if (form.Data?.FormID) {
      //         formMap[form.Data.FormID] = form.Data
      //       }
      //     })

         
      //     allPosts = allPosts.map(post => {
      //       if (
      //         post.Type === 'Form' &&
      //         post.Data?.FormID &&
      //         (!post.Data?.fields || post.Data.fields.length === 0) &&
      //         formMap[post.Data.FormID]
      //       ) {
      //         return {
      //           ...post,
      //           Data: {
      //             ...post.Data,
      //             ...formMap[post.Data.FormID] 
      //           }
      //         }
      //       }
      //       return post
      //     })
      //   } catch (formErr) {
      //     console.warn('Failed to enrich forms from /post/Form', formErr)
          
      //   }
      // }

     console.log({allPosts});
      allPosts.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn))

      setPosts(allPosts)
    } catch (err) {
      console.error('Failed to fetch posts', err)
    } finally {
      setLoading(false)
    }
  }

  

  return (
    <div id="appCapsule">
      <div className="section full mt-1">
        <div className="wide-block mt-1" ref={wideBlockRef}>
          <PageHeader
            title="Notices & updates"
            subtitle="Circulars, minutes, polls and forms from the society"
          />

          <PaymentDueAlert />

          {loading && <FeedSkeleton label="Loading updates" />}

          {!loading && posts.length === 0 && (
            <EmptyState
              icon="albums-outline"
              title="No updates yet"
              text="New notices, polls and forms will show up here."
            />
          )}

          {!loading && posts.length > 0 && (
          <ol className="timeline timed list-unstyled m-0">
            {posts.map(item => {
              const meta = typeMeta[item.Type] || typeMeta.Updates
              return (
                <li className="item" key={item.ID}>
                  <FeedTime value={item.CreatedOn} />

                  <div className={`dot ${meta.dot}`} aria-hidden="true"></div>

                  <div className="content">
                    <article className="card bl-feed-card">
                      <span className={`bl-chip ${meta.chip}`}>
                        <ion-icon name={meta.icon} aria-hidden="true"></ion-icon>
                        {meta.label}
                      </span>

                      {item.Type === 'Document' && <DocumentCard item={item} />}

                      {item.Type === 'Updates' && <UpdatesCard item={item} />}

                      {item.Type === 'Vote' && (
                        <PollQuestion
                          pollID={item.ID}
                          question={item.Data?.Question?.trim() || 'Untitled Poll'}
                          options={(item.Data?.Options || [])
                            .filter(Boolean)
                            .map((opt, index) => ({
                              optionId: index,
                              label: opt,
                              votes: item.Data?.Submissions?.[opt] ?? 0
                            }))}
                          MySubmission={item?.MySubmission?.Data?.SelectedOption ?? null}
                          onVoteSuccess={fetchAndEnrichPosts}
                        />
                      )}

                      {item.Type === 'Form' && (
                        <FormRenderCard item={item} reloadList={fetchAndEnrichPosts} />
                      )}
                    </article>
                  </div>
                </li>
              )
            })}
          </ol>
          )}
        </div>
      </div>
      <Pageopenmodal
        show={showmodal} 
        onClose={handleClose}/>
    </div>
  )
}

export default Updates